import { getCookie } from '@atlassian/browser-storage-controls';

import { atlassianStore as store } from 'src/utils/store';

// Historically we've used localstorage to determine if
// the user is a PDV bot. With Playwright we can't set
// localstorage before visiting a bitbucket page. But by
// the time we are on the page we have already seen any
// flags/etc. that would be shown to PDV bots. So we're
// adding cookie support as well.
export const isPdvBot = () => {
  return getCookie('is-pdv-bot') === 'true' || store.get('is-pdv-bot') === 1;
};
